module.exports = __webpack_public_path__ + "img/newbie.498dd452.svg";